// TODO: remove this enum and pull values from
export enum eEscrowWireDisbursementCategories {
  payoff = 'payoff',
  due_to_borrower = 'due_to_borrower',
  due_to_seller = 'due_to_seller',
  third_party = 'third_party',
}
